import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, HostListener, inject, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { CompositeFilterDescriptor, filterBy, process, State } from '@progress/kendo-data-query';
import * as _ from 'lodash';
import { ColumnComponent, DataStateChangeEvent, GridComponent, SelectionEvent, SortSettings } from '@progress/kendo-angular-grid';
import { CommonFunctions } from '../static/common-functions';
import { BaseBus } from '../models/BaseBus';
import { GlobalsService } from '../services/globals.service';
import { NotificationSettings } from '@progress/kendo-angular-notification';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { LineItemsSummary } from '../models/LineItemsSummary';
import { DQOIReferenceData } from '../models/DQOIReferenceData';
import { MessageType } from '../enums/MessageType';
import { UntypedFormGroup } from '@angular/forms';
import { BusinessObjectFactory } from '../models/BusinessObjectFactory';
import { DateFunctions } from '../static/date-functions';
import { v_InventoryBus } from '../models/v_InventoryBus';
import { InventoryService } from '../services/inventory.service';
import { BaseService } from '../services/base.service';
import { ConfirmOutput } from '../models/ConfirmOutput';
import { CRUDActions } from '../enums/CRUDActions';
import { CPDialogResult } from '../enums/CPDialogResult';
import { v_LocationDetailBus } from '../models/v_LocationDetailBus';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { CommonValues, GridEditModes } from '../static/CommonValues';
import { Subscription } from 'rxjs';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { Message } from '../models/message';
import { SaveMode } from '../enums/SaveMode';
import { GItem } from '../models/GItem';
import { SearchTarget } from '../enums/SearchTarget';
import { DQOIParam } from '../models/DQOIParam';
import { PersonSel } from '../models/PersonSelBus';
import { CommonParam } from '../models/CommonParam';
import { CPSearchComponent } from '../search/cp-search/cp-search.component';
import { ColumnBase, ExcelExportData } from '@progress/kendo-angular-excel-export';
import { BaseMessageInfo } from '../models/BaseMessageInfo';
import { AppClaims } from '../models/AppClaims';
import { MessageInfo } from '../models/MessageInfo';
import { MessageInfoType } from '../enums/MessageInfoType';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { EmptyOverridable, validateOverridables } from '../decorators/overridable/base-method-override-decorator';
import { environment } from '@env/environment';

const matches = (el, selector) => (el.matches || el.msMatchesSelector).call(el, selector);



export class GridEditLineParam {
    isEdited: any;
    dataItem: any;
    rowIndex: any;
    column: any;
    columnIndex: any;
    editClicked: boolean;
    constructor(isEdited: any, dataItem: any, rowIndex: any, column: any, columnIndex: any, editClicked: boolean) {
        this.isEdited = isEdited;
        this.dataItem = dataItem;
        this.rowIndex = rowIndex;
        this.column = column;
        this.columnIndex = columnIndex;
        this.editClicked = editClicked;
    }
}

@Component({
    selector: '',
    template: '',
    standalone: false
})
export abstract class BaseGridEditLineComponent<T extends BaseBus, D, S extends BaseService> implements OnInit, OnDestroy, AfterViewInit {

    protected internalFeatureFlagSet: any = {};
    private subs_internalFeatureFlagSet: Subscription;
    constructor(protected globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, protected featureFlagService: FeatureFlagService) {

        this.renderer = renderer;
        this.cd = cd;
        this.pageSize = this.globals.grid_PageSize;
        this.allData = this.allData.bind(this);
        this.subs_internalFeatureFlagSet = this.featureFlagService.featureFlagSets.subscribe(data => {
            this.internalFeatureFlagSet = data;
        });
        validateOverridables(this, Object.getPrototypeOf(this).constructor.name, BaseGridEditLineComponent);
    }
    protected hasFeatureFlag(key: string) {
        return this.internalFeatureFlagSet[key];
    }

    /*
    *This can be set to true on the component html to enable saving on grids nested in dialogs when there is already a mainGrid on the page
    */
    @Input() allowKendoPopupClicksToLeaveEditMode: boolean = false;

    @EmptyOverridable()
    customCheckBoxChanged(e: any, dataItem: T, rowIndex: number, column: ColumnComponent, columnIndex: number, setEditMode: boolean = true) { }

    @EmptyOverridable()
    public setup(data: string) { }

    @EmptyOverridable()
    cellCloseHandler(evt: any) { }

    @EmptyOverridable()
    keyPressEvent(event: KeyboardEvent) { }

    @EmptyOverridable()
    formValidChange() { }

    @EmptyOverridable()
    protected formValueChange() { }

    @EmptyOverridable()
    reFilterData() { }

    @EmptyOverridable()
    protected parentIdChanged() { }

    @EmptyOverridable()
    createForm() { }

    @EmptyOverridable()
    setForm() { }

    @EmptyOverridable()
    customCellClick(col: ColumnComponent) { }

    @EmptyOverridable()
    protected customPatchForm() { }

    @EmptyOverridable()
    protected afterSaveCurrent(data: T) { }

    @EmptyOverridable()
    protected save(data: T) { }

    @EmptyOverridable()
    protected customSaveLocal(data: T) { }

    @EmptyOverridable()
    protected afterAddNewData() { }

    @EmptyOverridable()
    protected afterSetInventorySearchData() { }

    @EmptyOverridable()
    protected beforeInventorySearchSetForm() { }

    @EmptyOverridable()
    protected beforeInventorySearchChangeInvItem(data: v_InventoryBus) { }

    @EmptyOverridable()
    afterDelete() { }

    @EmptyOverridable()
    deleteIndividual(data: T) { }

    @EmptyOverridable()
    deletedLocalNoId() { }

    @EmptyOverridable()
    confirmCustom(data: ConfirmOutput) { }

    @EmptyOverridable()
    customDispatchSelectedSetForm(value: any) { }

    @EmptyOverridable()
    processGridData() { }

    @EmptyOverridable()
    protected customMessageHandler(e: Message) { }

    public virtual: any = {
        itemHeight: 28,
    };

    subs_FormValidChange: Subscription;
    subs_FormValueChange: Subscription;
    public setupCheckForm() {
        this.subs_FormValidChange = this.editForm.statusChanges.subscribe(val => {
            this.formValidChange();

        });
        this.subs_FormValueChange = this.editForm.valueChanges.subscribe(val => {
            this.formValueChange();
        });
    }

    superUseCPRefData: boolean = false;

    gridEditLineParam: GridEditLineParam = null;
    isChildGrid: boolean = false;
    processingHotKey: boolean = false;
    subscribeToKeyPress: boolean = false;
    keyPressEventsSubscribedTo: any[];
    subs_keyPress: Subscription;
    private _rights: AppClaims | null = null;
    virtualizationSettings = CommonValues.virtualizationSettings;

    /**
     * Using this getter can cause race conditions in code depending on how this is used.
     * While we have a user data  resolver in place to help, this still could cause issues.
     * If you need reliable data from the user object, use CmProAuthService.subscribeToLoginEvents and CmProAuthService.unsubscribeToLoginEvents in your component
     *
     * @readonly
     * @type {AppClaims}
     * @memberof BaseGridEditLineComponent
     */
    get rights(): AppClaims {
        return this._rights ?? this.globals.user?.appClaims ?? new AppClaims();
    }

    set rights(value: AppClaims) {
        this._rights = value;
    }
    @Input() DefaultExport: any = "Excel";
    @Input() canDrag: boolean = false;
    hasTableGroups: boolean = false;
    searchTargetEnum: any = SearchTarget;
    pageSizeNoPaging: number = 0;
    noPaging: boolean = false;
    @Input() parentLoading: boolean = false;
    @Input() GridEditMode: number = 0; //0-Standard (click field), 1-Edit Button
    @Input() AppMode: number = 0; ////0-Standard, 1-QV?
    @Input() GridHeaderInfoMsg: string;
    get pageable(): boolean {
        return this.AppMode === 1 ? false : this.globals.grid_Pageable;
    }

    get filterable(): any {
        return this.AppMode === 1 ? false : "'menu'";
    }
    get groupable(): any {
        return false; // this.AppMode === 1 ? false : "{ showFooter: true }";
    }
    get canClickToEdit(): boolean {
        return this.GridEditMode !== GridEditModes.editButton;
    }
    get isSorted(): boolean {
        return CommonFunctions.hasValue(this.grid) && CommonFunctions.hasArrayElementValue(this.grid.sort) && CommonFunctions.hasStringValue(this.grid.sort[0].dir) ? true : false;
    }
    canDelete(dataItem: T): boolean {
        return true;
    }
    protected gridDataDuringEdit: T[];
    @Input() gridData: T[];
    @Input() set ListData(lData: T[]) {
        this.gridData = CommonFunctions.hasArrayElementValue(lData) ? lData : [];
        this.clearDeleted();
        this.cloneData();
        this.reFilterData();
        this.processGridData();
    }

    get gridLength(): number {
        //TODO BW: set up height for responsive screens.
        let height = this.gridData_Length > this.globals.grid_LineCount ? this.globals.grid_Height : null;
        return height;
    }

    @Input() isSelected: boolean = false;
    className: string = "";
    svc_data: S;
    selectedData: T;
    selectedRowData: T;
    protected svc_inv: InventoryService = inject(InventoryService);
    protected disableInventoryService() {
        this.svc_inv = null;
    }

    renderer: Renderer2;
    cd: ChangeDetectorRef;
    deletedItems: GItem[] = [];
    appCode: string = "Item";
    appName: string = this.appCode;
    originalData: T[];
    get hasInvSvc(): boolean {
        return CommonFunctions.hasValue(this.svc_inv);
    }
    @Input() saveMode: any = SaveMode.individual;

    @ViewChild('grid') public gridP: GridComponent;
    @ViewChild('grid') protected grid: GridComponent;
    @ViewChild('detail') protected detail: D;
    @ViewChild('cnfDialog') protected cnfDialog: ConfirmDialogComponent;
    @ViewChild('cpDispatchSearch') protected CpDispatchSearch: CPSearchComponent;

    @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;
    @Input() noParentRequired: boolean = false;
    protected _parentId: any;
    protected _dbTable: any;
    @Input() readOnly: boolean = false;
    @Input() summary: LineItemsSummary;
    @Input() referenceData: DQOIReferenceData;
    @Input() canEdit: boolean = false;
    @Input() set parentId(value: any) {
        if (value !== undefined && value !== null) {
            let isDifferent: boolean = this._parentId !== value;
            this._parentId = value;
            if (this.actionSave) {
                this.actionSave = false;
                this.saveCurrent();
            }
            if (isDifferent) {
                this.parentIdChanged();
            }
        }
    }
    get parentId(): any {
        return this._parentId;
    }

    @Input() locationDetail: v_LocationDetailBus;
    @Input() isConstruction: boolean;

    @Output() parentMessage: EventEmitter<Message> = new EventEmitter<Message>();
    @Output() selected: EventEmitter<any> = new EventEmitter();
    @Output() closed: EventEmitter<any> = new EventEmitter<any>();
    @Output() closedWithInfo: EventEmitter<BaseMessageInfo> = new EventEmitter<BaseMessageInfo>();

    viewingDocument: boolean = false;
    @Input() dataLoading: boolean = false;
    @Input() common: CommonParam;
    protected get hasCommon(): boolean {
        return CommonFunctions.hasValue(this.common);
    }
    protected getCommon() {
        if (!this.hasCommon) {
            this.common = new CommonParam();
        }
        return this.common;
    }
    @Output() doAction: EventEmitter<CommonParam> = new EventEmitter<CommonParam>();
    get hasReferenceData(): boolean {
        let retVal: boolean = false;
        try {
            retVal = this.referenceData !== undefined && this.referenceData !== null && this.referenceData.dispatchStatus !== undefined && this.referenceData.dispatchStatus !== null ? true : false;
        }
        catch {
            retVal = false;
        }
        return retVal;

    }
    get gridData_Length(): number {
        return CommonFunctions.hasArrayElementValue(this.gridData) ? this.gridData.length : 0;
    }
    pageSize: number;
    skip: number;
    public editForm: UntypedFormGroup;
    protected editedRowIndex: number;
    protected isNew: boolean = false;
    protected actionSave: boolean = false;
    showCpSearchDialog: boolean = false;
    protected inventorySvcField: string = "inventoryNumber";
    protected openCpSearchOnAdd: boolean = true;
    protected inventorySearching: boolean = false;
    prevSortableSettings: any;
    prevFilterableSettings: any;
    public sortableSettings: SortSettings = { allowUnsort: true };
    public filterableSettings: any = "menu";
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
    public filter: CompositeFilterDescriptor;
    public filterChange(filter: CompositeFilterDescriptor): void {
        this.filter = filter;
        this.gridData = filterBy(this.originalData, filter);
        this.processGridData();
    }

    public aggregates: any[] = [];
    public aggregateResults;
    public state: State = {
        skip: 0,
        take: 1000,
        group: []
    };
    public dataStateChange(state: DataStateChangeEvent): void {
        if (state && state.group) {
            state.group.map(group => group.aggregates = this.aggregates);
        }
        this.state = state;
    }
    messageSubs: Subscription;

    ngOnInit() {
        this.pageSize = this.AppMode !== 1 ? this.globals.grid_PageSize : 0;
        if (this.subscribeToKeyPress) {
            CommonFunctions.unsubscribe(this.subs_keyPress);
            this.subs_keyPress = this.globals.keyPress$.subscribe((event: KeyboardEvent) => {
                if (this.isSelected === true && event != null) {
                    this.processingHotKey = true;
                    this.keyPressEvent(event);
                }
                else {
                    this.processingHotKey = false;
                }
            });
        }
    }
    doParentAction(id: any, actionCode: string, dataCode: string) {
        let param: CommonParam = new CommonParam();
        param.addParam("ACTION", actionCode);
        param.addParam("CODE", dataCode);
        param.addParam("ID", id);
        this.doAction.emit(param);
    }
    ngAfterViewInit() {
        this.getCommon();
    }
    ngOnDestroy() {
        CommonFunctions.unsubscribe(this.messageSubs);
        CommonFunctions.unsubscribe(this.subs_keyPress);
        CommonFunctions.unsubscribe(this.subs_FormValidChange);
        CommonFunctions.unsubscribe(this.subs_FormValueChange);
        CommonFunctions.unsubscribe(this.subs_internalFeatureFlagSet);
    }

    clear() {
        this.deletedItems = [];
        this.gridData = [];
        this.originalData = null;
        this.gridDataDuringEdit = null;
    }

    clearDeleted() {
        this.deletedItems = [];
    }

    cloneData() {
        this.originalData = _.cloneDeep(this.gridData);
    }
    get hasParentId(): boolean {
        return CommonFunctions.hasValue(this._parentId);
    }
    get canAddEdit(): boolean {
        return (!this.readOnly && (this.canEdit || (CommonFunctions.hasValue(this._parentId) && this.saveMode == SaveMode.individual))) ? true : false;
    }
    get canSave(): boolean {
        return true;
    }
    get hasGridData(): boolean {
        return CommonFunctions.hasArrayValue(this.gridData);
    }
    get hasSelectedData(): boolean {
        return CommonFunctions.hasValue(this.selectedData);
    }
    get hasEditForm(): boolean {
        return this.editForm !== undefined && this.editForm !== null ? true : false;
    }
    get isEditing(): boolean {
        return this.editForm !== undefined && this.editForm !== null ? true : false;
    }
    get isDirty(): boolean {
        return !this.readOnly && this.hasEditForm && this.editForm.dirty;
    }
    cannotSaveMessage(msgNo: number): MessageInfo {
        let msg: MessageInfo = null;
        if (this.isEditing && !this.canSaveForm) {
            msg = new MessageInfo();
            msg.messageNo = msgNo;
            msg.message = this.customCannotSaveMessage();
            msg.messageType = MessageInfoType.warning;
        }
        return msg;
    }
    customCannotSaveMessage(): string {
        return "Cannot Save " + this.appName;
    }
    setDirty() {
        if (this.hasEditForm) {
            this.editForm.markAsDirty();
        }
    }
    setPristine() {
        if (this.hasEditForm) {
            this.editForm.markAsPristine();
        }
    }
    get showExport(): boolean {
        return this.AppMode !== 1;
    }

    canEditRow(dataItem: T, column: ColumnBase = null) {
        return this.hasRowEditRights(dataItem);
    }
    hasRowEditRights(dataItem: T): boolean {

        return dataItem.inFinance ? this.rights.FinancialLockOverride : true;
    }
    goToWithParam(param: DQOIParam) {
        this.sendParentMessage(MessageType.goTo, null, null, param);
    }
    goTo(data: any, target: SearchTarget) {
        let param: DQOIParam = new DQOIParam();
        param.target = target;
        param.id = data;
        param.data = data;
        param.code = "GOTO";
        this.sendParentMessage(MessageType.goTo, null, null, param);

    }
    goToPopup(data: any, target: SearchTarget) {
        let param: DQOIParam = new DQOIParam();
        param.target = target;
        param.id = data;
        param.data = data;
        param.code = "GOTO";
        this.sendParentMessage(MessageType.goTo, null, null, param, data);

    }
    getGridData(data: T[]): T[] {
        if (CommonFunctions.hasArrayElementValue(data)) {
            let arr = [];
            for (let i = 0; i < data.length; i++) {
                let dataObj: T = this.createNew(data[i]);
                arr.push(dataObj);
            }
            return arr;
        }
        return data;
    }
    addDeletedItem(data: T) {
        this.deletedItems.push({ description: this.appCode, value: data.CID(), category: null, "reference": null, canSelect: true });
    }
    public addDeletedItemGItem(data: GItem) {
        this.deletedItems.push(data);
    }

    rowSelected(e: SelectionEvent) {
        if (!this.hasEditForm) {
            this.selectedData = e.selectedRows[0].dataItem;
        }
    }
    select(e: T) {
        this.selected.emit(e);
    }

    /**
    * @deprecated This notify is deprecated and will be removed in future versions. Deprecated on: 02.19.2025
    */
    notify(notification: string, type: string = "S", closable: boolean = null, settings: NotificationSettings = null) {
        this.globals.notify(notification, type, closable, settings);
    }

    protected markControlDirty(fieldName: string) {
        if (this.hasEditForm) {
            this.editForm.controls[fieldName].markAsDirty();
        }
    }
    checkBoxChanged(e: any, dataItem, rowIndex, column, columnIndex, setEditMode: boolean = true) {
        let row_isEdited: boolean = CommonFunctions.hasValue(this.editedRowIndex) && this.editedRowIndex === rowIndex;
        if (!row_isEdited && setEditMode) {
            this.cellClickHandler({ isEdited: row_isEdited, dataItem: dataItem, rowIndex: rowIndex, column: column, columnIndex: columnIndex });
            this.customCheckBoxChanged(e, dataItem, rowIndex, column, columnIndex, setEditMode);
            this.setDirty();
        }
        else {
            this.customCheckBoxChanged(e, dataItem, rowIndex, column, columnIndex, setEditMode);
        }
    }

    whenSaveIndividualDontCloseEditor: boolean = false;


    /**
     * This is used to change the row to edit mode from a button click
     *
     * @param {*} dataItem
     * @param {*} rowIndex
     * @param {*} column
     * @param {*} columnIndex
     * @memberof BaseGridEditLineComponent
     */
    public rowEditHandler(dataItem, rowIndex, column, columnIndex) {
        this.cellClickHandler({ isEdited: false, dataItem: dataItem, rowIndex: rowIndex, column: column, columnIndex: columnIndex }, true);
    }

    public cellClickHandler({ isEdited, dataItem, rowIndex, column, columnIndex }, editClicked: boolean = false): void {

        this.gridEditLineParam = null;
        if (this.saveMode === SaveMode.individual && (CommonFunctions.hasValue(this.editedRowIndex) || this.isNew)) {
            this.gridEditLineParam = new GridEditLineParam(isEdited, dataItem, rowIndex, column, columnIndex, editClicked);
            //this.gridEditLineParam
            if (this.isDirty && this.canSave) {
                this.gridEditLineParam = new GridEditLineParam(isEdited, dataItem, rowIndex, column, columnIndex, editClicked);
                this.saveCurrent();
            }
            else {
                if (!this.isDirty) {
                    this.closeEditor();
                    if (CommonFunctions.hasValue(this.gridEditLineParam)) {
                        //{ isEdited, dataItem, rowIndex, column, columnIndex }, editClicked
                        this.cellClickHandler({
                            isEdited: this.gridEditLineParam.isEdited,
                            dataItem: this.gridEditLineParam.dataItem,
                            rowIndex: this.gridEditLineParam.rowIndex,
                            column: this.gridEditLineParam.column,
                            columnIndex: this.gridEditLineParam.columnIndex
                        }, this.gridEditLineParam.editClicked);
                    }
                }
            }
            return;
        }
        if ((this.GridEditMode === GridEditModes.editButton && editClicked === false)
            || !this.canEditRow(dataItem, column)
            || !this.canAddEdit
            || this.readOnly
            || (!CommonFunctions.hasStringValue(column.field) && editClicked === false)
            || this.viewingDocument
            || isEdited
            || (this.editForm && !this.editForm.valid)) {
            //this is an odd inner check
            if (this.GridEditMode === GridEditModes.editButton && editClicked === false && this.isEditing) {
                this.saveCurrent();
            }
            return;
        }
        else if (this.hasEditForm && (!this.canSave || !this.canSaveForm)) {
            return;
        } else if (!column.editable && editClicked === false) {
            return;
        }
        this.prevFilterableSettings = this.filterableSettings;
        this.prevSortableSettings = this.sortableSettings;
        this.filterableSettings = false;
        this.sortableSettings = false;
        this.ctrlOpenFlag = false;
        this.closeCtrlOpenFlag = false;

        let l_col: ColumnComponent = column;
        if (this.saveMode === SaveMode.individual && this.editedRowIndex !== rowIndex) {
            this.whenSaveIndividualDontCloseEditor = true;
        }
        this.saveCurrent();
        this.createForm();
        this.gridDataDuringEdit = _.cloneDeep(this.gridData);
        this.selectedData = this.createNew(dataItem);
        this.setForm();
        if (!this.isSorted && !_.isEqual(dataItem, this.gridData[rowIndex])) {
            rowIndex = rowIndex + 1;
        }
        this.editedRowIndex = rowIndex;
        this.grid.editRow(rowIndex, this.editForm);

        setTimeout(() => {
            let elem: HTMLElement = (<HTMLElement>document.querySelector(`.k-grid-edit-row > td:nth-child(${columnIndex + 1 + this.columnFocusAdder}) input`));
            if (elem) {
                elem.focus();
            }
        });

        //NOTE: [dturco 03.13.2025] This logic needs to be re-visted. If i set showCpSearchDialog to false, just because i have a column in my form that matches the inventorySvcField does not mean i want to fire search
        if (l_col.field === this.inventorySvcField && this.inventorySvcField !== undefined && this.inventorySvcField !== null) {
            this.showCpSearchDialog = true;
        }
        this.customCellClick(l_col);
    }
    columnFocusAdder: number = 0;

    /**
     * This searches up the dom tree from the clicked element to see if any parent element has the attribute propagateAllowKendoPopupClicksToLeaveEditModeToAllChildren. This can be used in a multi-grid scenario where you want to ignore kendo popups on document click for all child grids
     *
     * @private
     * @param {HTMLElement} element
     * @return {*}  {boolean}
     * @memberof BaseGridEditLineComponent
     */
    private hasPropagateAllowKendoPopupClicksToLeaveEditModeToAllChildren(element: HTMLElement): boolean {
        let currentElement: HTMLElement | null = element;

        while (currentElement !== null) {
            if (currentElement.getAttribute('propagateAllowKendoPopupClicksToLeaveEditModeToAllChildren') === 'true') {
                return true;
            }
            currentElement = currentElement.parentElement;
        }

        return false;
    }

    /**
     * Checks if the clicked element is inside a popup, and if so, determines if this popup is nested inside another popup.
     * Returns true if the clicked element is inside a popup that is itself inside another popup; otherwise, returns false.
     *
     * @param {HTMLElement} element - The clicked element to check.
     * @returns {boolean} - True if nested popup, false otherwise.
     */
    private isElementInNestedPopup(element: HTMLElement): boolean {
        let currentElement: HTMLElement | null = element;
        let foundFirstPopup = false;

        if (this.internalFeatureFlagSet['ui-enable-new-logic-for-basegrideditline-in-popup']) {
            while (currentElement !== null && currentElement.getAttribute('propagateAllowKendoPopupClicksToLeaveEditModeToAllChildren') !== 'true') {
                if (this.excludedPopupElements.some(selector => currentElement.matches(selector))) {
                    if (!foundFirstPopup) {
                        foundFirstPopup = true; // Found the first popup
                    } else {
                        // Found a second (parent) popup
                        return true;
                    }
                }
                currentElement = currentElement.parentElement;
            }
            return false;
        }
        else {
            //old logic
            while (currentElement !== null) {
                if (this.excludedPopupElements.some(selector => currentElement.matches(selector))) {
                    if (!foundFirstPopup) {
                        foundFirstPopup = true; // Found the first popup
                    } else {
                        // Found a second (parent) popup
                        return true;
                    }
                }
                currentElement = currentElement.parentElement;
            }
            return false;
        }
    }

    private excludedPopupElements = [
        'kendo-window',
        'kendo-dialog',
        '.k-overlay',
        '.k-popup',
        'kendo-popup',
        'confirm-dialog',
        '.cp-window',
        '.kendo-upload'
    ];

    @HostListener('document:mousedown', ['$event'])
    private tryAddDocumentClickListener(e: MouseEvent) {

        if (!this.editForm?.valid) {
            return;
        }
        const editForm = document.querySelector('.k-grid-edit-row') as HTMLElement;
        if (!editForm) return; // No edit form, exit early

        const clickedElement = e.target as HTMLElement;

        const buttonMatcher = '.k-grid-toolbar button, .k-grid-toolbar .k-button, .k-grid-toolbar .k-button *';
        //NOTE: [dturco 03.12.2025] Sourced from GTP and then expanded upon
        const excludedElements = [
            'kendo-dropdownlist',
            'kendo-combobox',
            'kendo-multiselect',
            'kendo-datepicker',
            'kendo-timepicker',
            'kendo-datetimepicker',
            'kendo-list',
            buttonMatcher
        ];

        const propagateAllowKendoPopupClicksToLeaveEditModeToAllChildren = this.hasPropagateAllowKendoPopupClicksToLeaveEditModeToAllChildren(clickedElement);
        const allowChildKendoPopupClicksStayInEditMode = this.isElementInNestedPopup(clickedElement);

        if (allowChildKendoPopupClicksStayInEditMode || (!this.allowKendoPopupClicksToLeaveEditMode && !propagateAllowKendoPopupClicksToLeaveEditModeToAllChildren)) {
            excludedElements.push(...this.excludedPopupElements);
        }
        const excludedElementsString = excludedElements.join(',');
        const matchedElement = clickedElement.closest(excludedElementsString);
        const isKendoExcludedElementClicked = matchedElement !== null;
        if (environment.debug) {
            console.debug(`%c Excluded element clicked: ${isKendoExcludedElementClicked}. Exclusions: ${excludedElementsString} propagateAllowKendoPopupClicksToLeaveEditModeToAllChildren: ${propagateAllowKendoPopupClicksToLeaveEditModeToAllChildren}`, CommonValues.LoggingMessage_ColorBlue, clickedElement, matchedElement);
        }
        if (isKendoExcludedElementClicked) {
            return; // Clicked on an excluded element, exit early
        }

        // Check if the clicked element is inside the main grid or toolbar buttons
        // This was existing code, that could be a candidate for refactor
        const isMainGridClicked = matches(clickedElement, '#mainGrid tbody *, #mainGrid .k-grid-toolbar .k-button .k-link');
        //NOTE: [dturco 03.16.2025] As of now there is ony 1 childgrid: TimeSheetDetailComponent
        const isChildGridClicked = matches(clickedElement, '#childGrid tbody *, #childGrid .k-grid-toolbar .k-button .k-link');

        // if you need to detect whether the current focus is inside #mainGrid, then keeping isActiveElementInsideMainGrid makes sense. This might be relevant if you're handling cases where focus shifts dynamically (e.g., closing dropdowns, managing keyboard navigation, or preventing unintended blur events).
        const isActiveElementInsideMainGrid = document.activeElement && matches(document.activeElement, '#mainGrid tbody *');

        const isNotMainGridClicked = (
            !this.isChildGrid &&
            !isMainGridClicked &&
            !isActiveElementInsideMainGrid
        );

        const isNotChildGridClicked = (
            this.isChildGrid &&
            !isChildGridClicked &&
            !isActiveElementInsideMainGrid
        );
        const gridContainer = clickedElement.closest('.k-grid') as HTMLElement;
        const clickedRow = clickedElement.closest('.k-grid tr') as HTMLElement;
        const notEditFormClicked = !editForm.contains(clickedElement);
        // Trigger the event if:
        // - Click is outside the edit row
        // - Click is inside the grid but not on a row (empty space)
        // - Click is outside both main and child grids (previous logic)
        if (environment.debug) {
            console.debug(`%c Document clicked evaluations: notEditFormClicked: ${notEditFormClicked} gridContainerNotClikedRow: ${(gridContainer && !clickedRow)} isNotMainGridClicked: ${isNotMainGridClicked} isNotChildGridClicked: ${isNotChildGridClicked}`, CommonValues.LoggingMessage_ColorBlue, clickedElement);
        }
        if (notEditFormClicked
            || (gridContainer && !clickedRow)
            || isNotMainGridClicked
            || isNotChildGridClicked) {
            //NOTE: [dturco 03.14.2025] We need to delay this just so the js event loop can process first. This handles having other attached events to a cell or row like OnBlur
            setTimeout(() => {
                this.onDocumentClick(e);
            }, 10);

        }
    }

    createNew(data: T = null): T {
        let newData: T = BusinessObjectFactory.Create(this.className, data);
        return newData;
    }
    createNewSaveVersion(className: string, data: any = null): any {
        let busObj: any = BusinessObjectFactory.Create(className, data);
        return busObj;
    }

    protected getMaxOrderValue(): number {
        let orderValue: number = 0;
        if (CommonFunctions.hasArrayValue(this.gridData)) {
            for (let i = 0; i < this.gridData.length; i++) {
                if (orderValue < this.gridData[i].orderValue) {
                    orderValue = this.gridData[i].orderValue;
                }
            }
        }
        return orderValue;
    }
    protected getMinOrderValue(): number {
        let orderValue: number = 0;
        if (CommonFunctions.hasArrayValue(this.gridData)) {
            for (let i = 0; i < this.gridData.length; i++) {
                if (orderValue > this.gridData[i].orderValue) {
                    orderValue = this.gridData[i].orderValue;
                }
            }
        }
        return orderValue;
    }
    protected reOrder(): void {
        if (CommonFunctions.hasArrayValue(this.gridData)) {
            for (let i = 0; i < this.gridData.length; i++) {
                this.gridData[i].orderValue = i + 1;
            }
        }
    }
    setFromNonFormData(data: T) {
        return data;
    }
    setFromReferenceData(data: T) {
        return data;
    }
    callSaveIndividualInsteadOfSave: boolean = false;
    protected saveCurrent(): void {
        if (this.editForm) {
            this.customPatchForm();
            let data: T;
            if (this.isNew) {
                if (this.isNew && this.selectedData.isAdded) {
                    //when addHandler is called we already do all this work
                    data = this.selectedData;
                } else {
                    data = this.createNew(null);
                }
            } else {
                data = this.selectedData;
            }

            data.setFromForm(this.editForm.value);
            data = this.setFromNonFormData(data);
            data.setParentId(this._parentId);
            data.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
            data = this.setFromReferenceData(data);
            if (data.usesOrderValue && !data.hasOrderValue) {
                let orderValue: number = this.getMaxOrderValue() + 1;
                data.orderValue = orderValue;
            }
            if (this.isNew) {
                data.isAdded = true;
            }
            if (!data.isAdded) {
                data.isUpdated = true;
            }
            if (this.saveMode === SaveMode.individual) {
                if (!this.callSaveIndividualInsteadOfSave) {
                    this.save(data);
                }
                else {
                    this.saveIndividual(data).then((res: BaseMessageInfo) => {
                        if (!res.saveError) {
                            let data: T = res.primaryReturn;
                            this.customSaveLocal(data);
                            this.saveLocal(data, this.isNew);
                            if (data) {
                                data.isAdded = false;
                                data.isUpdated = false;
                            }
                        } else {
                            this.globals.notifyError("Save Encountered an Error: " + res.message, true);
                        }
                        this.closeEditor();
                        this.afterSaveCurrent(data);
                        this.whenSaveIndividualDontCloseEditor = false;
                        if (CommonFunctions.hasValue(this.gridEditLineParam)) {
                            this.cellClickHandler({
                                isEdited: this.gridEditLineParam.isEdited,
                                dataItem: this.gridEditLineParam.dataItem,
                                rowIndex: this.gridEditLineParam.rowIndex,
                                column: this.gridEditLineParam.column,
                                columnIndex: this.gridEditLineParam.columnIndex
                            }, this.gridEditLineParam.editClicked);
                        }

                    }, err => {
                        //this handles server errors not caught by all the try catches in the API
                        console.error(err);
                        this.closeEditor();
                        this.afterSaveCurrent(data);
                    });
                }
            }
            else {
                if (this.isNew && !CommonFunctions.hasGuidValue(data.CID())) {
                    data.setId(CommonFunctions.getGuid());
                }
                this.customSaveLocal(data);
                this.saveLocal(data, this.isNew);
                this.closeEditor();
                this.SetChanged();
                this.afterSaveCurrent(data);
            }
        }
    }
    protected removeLocalAdded() {
        this.gridData = _.remove(this.gridData, function (n) {
            return !n.isAdded;
        });
        this.cloneData();
    }
    protected SetChanged() {
        this.sendParentMessage(MessageType.changed);
    }

    public getCount(): number {
        let count: number = 0;
        if (this.hasGridData) {
            count = this.gridData.length;
        }
        return count;
    }
    get hasCount(): boolean {
        let count: number = this.getCount();
        return count > 0;
    }
    public getChanged(param: any = null): any {
        if (this.isEditing && this.canSaveForm) {

            this.saveCurrent();
        }
        let changedData: T[] = [];
        if (this.hasGridData) {
            for (let i = 0; i < this.gridData.length; i++) {
                if (this.gridData[i].isUpdated || this.gridData[i].isAdded) {
                    let dataObj = this.getChangedObject(this.gridData[i]);
                    changedData.push(dataObj);
                }
            }
        }
        return changedData;
    }
    public setChangedOff() {
        if (this.hasGridData) {
            for (let i = 0; i < this.gridData.length; i++) {
                if (this.gridData[i].isUpdated || this.gridData[i].isAdded) {
                    this.gridData[i].isUpdated = false;
                    this.gridData[i].isAdded = false;
                }
            }
        }
    }
    protected getChangedObject(data: any) {
        return data;
    }
    public getAll(): any {
        return _.cloneDeep(this.gridData);
    }
    public getDeletedItems() {
        return _.cloneDeep(this.deletedItems);
    }

    protected saveSuccess(data: T) {
        if (CommonFunctions.hasValue(data)) {
            this.saveLocal(data, this.isNew);
        }
        this.globals.notifySuccess(this.appCode + " Saved Successfully!");
        this.closeEditor();
        this.whenSaveIndividualDontCloseEditor = false;
    }
    protected saveError(data: T, message: string) {
        this.globals.notifyError("Save Encountered an Error: " + message, true);
        this.closeEditor();
    }
    public saveHandler() {
        this.saveCurrent();
    }
    protected saveIndividual(data: T): Promise<BaseMessageInfo> {
        return new Promise((resolve, reject) => {
            resolve(new BaseMessageInfo());
        });
    }

    protected saveLocal(data: T, isNew: boolean) {
        if (!CommonFunctions.hasArrayElementValue(this.gridData)) {
            this.gridData = [];
        }
        if (isNew) {
            this.gridData.splice(0, 0, data);
            if (this.internalFeatureFlagSet['flags-inventory-duplicating-part-warehouse']) {
                if (this.originalData) {
                    if (!this.originalData.find(a => a.CID() === data.CID())) {
                        this.originalData.splice(0, 0, data);
                    }
                }
            }
        }
        else {
            Object.assign(
                this.gridData.find(a => a.CID() === data.CID()),
                data
            );
            if (this.internalFeatureFlagSet['flags-inventory-duplicating-part-warehouse']) {
                if (this.originalData) {
                    if (!this.originalData.find(a => a.CID() === data.CID())) {
                        this.originalData.splice(0, 0, data);
                    } else {
                        Object.assign(
                            this.originalData.find(a => a.CID() === data.CID()),
                            data
                        );
                    }
                }
            }

        }
        if (!this.internalFeatureFlagSet['flags-inventory-duplicating-part-warehouse']) {
            this.cloneData();
        }

        this.cd.detectChanges();
    }
    protected removeFromGridData(data: T) {
        if (CommonFunctions.hasArrayValue(this.gridData)) {
            this.gridData = _.remove(this.gridData, function (n) {
                return n.CID() !== data.CID();
            });
        }
    }
    protected removeLocal(data: T) {
        this.gridData = _.remove(this.gridData, function (n) {
            return n.CID() !== data.CID();
        });
        if (this.internalFeatureFlagSet['flags-inventory-duplicating-part-warehouse']) {
            if (this.originalData) {
                this.originalData = _.remove(this.originalData, function (n) {
                    return n.CID() !== data.CID();
                });
            }
        }
        if (!this.internalFeatureFlagSet['flags-inventory-duplicating-part-warehouse']) {
            this.cloneData();
        }
    }

    public activeOrSelected(inArray: any[], selectedId: any): any {
        return inArray?.filter(item => item.canSelect == true || item.value == selectedId) ?? [];
    }
    public cancelHandler(): void {
        this.gridData = _.cloneDeep(this.gridDataDuringEdit);
        this.closeEditor();
    }
    protected closeEditor(): void {
        //The row index that will be switched out of the edit mode. If no index is provided, it is assumed that the new item editor will be closed.
        this.grid.closeRow(this.editedRowIndex);

        this.isNew = false;
        this.editedRowIndex = undefined;
        this.editForm = undefined;
        this.showCpSearchDialog = false;
        this.filterableSettings = this.prevFilterableSettings;
        this.sortableSettings = this.prevSortableSettings;
        this.cd.detectChanges();
        if (this.grid.pageSize) {
            this.grid.data = {
                data: this.gridData.slice(this.grid.skip, this.grid.skip + this.grid.pageSize),
                total: this.gridData_Length

            };
        }
        else {
            if (this.hasTableGroups) {
                this.processGridData();
            }
            else {
                this.grid.data = {
                    data: this.gridData,
                    total: this.gridData_Length
                };

            }
        }

    }

    private tryProcessFormDirtyOnAdd() {
        //This is when an existing new row is in edit mode and the user clicks add new
        if (this.hasEditForm && this.isDirty) {
            if (!this.hasParentId && this.saveMode === SaveMode.individual) {
                this.actionSave = true;
                this.sendParentMessage(MessageType.saveParent);
            }
            else if (this.canSaveForm) {
                this.saveCurrent();
                this.sendParentMessage(MessageType.changed);
            }
        }
        else {
            this.closeEditor();
        }
    }

    /**
     * Ensures that the edit form is in edit mode. If the edit form does not exist,
     * it initializes the form, sets it up, and associates it with the grid's current
     * edited row. Finally, it triggers change detection to update the view.
     *
     * @remarks
     * - This method is typically used when the child component is deeply layered inside a windows,
     *   and a cp-search is needed to be shown but also the window is using the
     *   propagateAllowKendoPopupClicksToLeaveEditModeToAllChildren attribute.
     * - This method is typically used to guarantee that the grid's edit functionality
     *   is properly initialized and active.
     * - The `editedRowIndex` property determines which row is being edited. If it is
     *   not set, the first row (index 0) is used by default.
     *
     * @throws
     * May throw an error if the form creation or grid editing process encounters an issue.
     */
    public ensureEditFormInEditMode() {
        if (!this.editForm) {
            this.createForm();
            this.setForm();
            this.grid.editRow(this.editedRowIndex ?? 0, this.editForm);
            this.cd.detectChanges();
        }
    }
    public addHandler(): void {
        this.tryProcessFormDirtyOnAdd();
        let date: Date = DateFunctions.getDateNow();
        this.selectedData = this.createNew(null);
        this.selectedData.isAdded = true;
        if (this.selectedData.usesOrderValue) {
            this.selectedData.orderValue = this.getNewOrderValue(); // this.getMaxOrderValue() + 1;
        }
        this.selectedData.setNew(this.globals.userId, date, this.globals.companyId, this.globals.personId, this._parentId, this.locationDetail);
        this.afterAddNewData();
        if (!this.customAddNew()) {
            this.createForm();
            this.setForm();
            if (!CommonFunctions.hasArrayValue(this.gridData)) {
                this.gridData = [];
            }
            this.gridDataDuringEdit = _.cloneDeep(this.gridData);
            this.isNew = true;
            this.grid.addRow(this.editForm);
            //NOTE: [dturco 03.14.2025] This is used as a flag to show on add new click the cp-search for finding some sort of data. It originally was just for inventory, but has since been used more generically, if any type of search needs to be done we pop the dialog
            if (this.openCpSearchOnAdd) {
                this.showCpSearchDialog = true;
            }
        }
    }
    public addAtEndHandler(): void {
        this.tryProcessFormDirtyOnAdd();
        let date: Date = DateFunctions.getDateNow();
        this.selectedData = this.createNew(null);
        this.selectedData.isAdded = true;
        if (this.selectedData.usesOrderValue) {
            this.selectedData.orderValue = this.getNewOrderValue(); // this.getMaxOrderValue() + 1;
        }
        this.selectedData.setId(CommonFunctions.getGuid());
        this.selectedData.setNew(this.globals.userId, date, this.globals.companyId, this.globals.personId, this._parentId, this.locationDetail);
        this.afterAddNewData();
        if (!this.customAddNew()) {
            this.createForm();
            this.setForm();
            if (!CommonFunctions.hasArrayValue(this.gridData)) {
                this.gridData = [];
            }
            this.gridDataDuringEdit = _.cloneDeep(this.gridData);
            //NOTE: [dturco 03.13.2025] It is odd this is different than the addHandler when we are still adding a row.
            this.gridData.push(this.selectedData);
            this.isNew = false;
            this.editedRowIndex = this.gridData.length - 1;
            this.grid.editRow(this.editedRowIndex, this.editForm);
            if (this.openCpSearchOnAdd) {
                this.showCpSearchDialog = true;
            }
        }
    }
    getNewOrderValue(): number {
        return this.getMaxOrderValue() + 1;
    }


    /**
     * Disables the flags that control the cpsearch dialog.
     * This also clears the inventorySvcField property. This property is specific to using the cpsearch dialog for inventory items.
     * Properties Affected: openCpSearchOnAdd, inventorySearch, inventorySvcField
     *
     * @memberof BaseGridEditLineComponent
     */
    protected disableCpSearchDialog(disableInventorySvcField: boolean = true) {
        this.openCpSearchOnAdd = false;
        this.showCpSearchDialog = false;
        if (disableInventorySvcField) {
            this.inventorySvcField = undefined;
        }
    }

    protected customAddNew(): boolean {
        return false;
    }

    setInventorySearchData(value: any, useNotifyCompleteMessaging: boolean = true) {
        if (!this.hasInvSvc) {
            this.globals.notifyError(`There was an issue completing the inventory search. ${CommonValues.ErrorMessages_BaseErrorSuffix}`);
            throw new Error("Inventory service was not set. Please set this.svc_inv` in calling constructor.");
        }
        this.inventorySearching = true;
        this.svc_inv.getViewById(value.InventoryId).subscribe(
            {
                next:
                    (data: v_InventoryBus) => {
                        this.beforeInventorySearchChangeInvItem(data);
                        this.selectedData.changeInventoryItem(data);
                        this.beforeInventorySearchSetForm();
                        this.setForm();
                        this.afterSetInventorySearchData();
                        this.inventorySearching = false;
                        if (!this.hasFeatureFlag("ui-hide-inventory-still-searching-notification") && useNotifyCompleteMessaging) {
                            this.globals.notifyInfo("Inventory search item selected. You can now click out of the edit row.");
                        }
                    },
                error: (error: any) => {
                    console.error(error);
                    this.inventorySearching = false;
                    if (!this.hasFeatureFlag("ui-hide-inventory-still-searching-notification") && useNotifyCompleteMessaging) {
                        this.globals.notifyError(`There was an issue completing the inventory search. ${CommonValues.ErrorMessages_BaseErrorSuffix}`);
                    }
                }
            });
    }
    inventorySelected(value: any) {
        if (!this.hasInvSvc) {
            console.error("Inventory service was not set. Please set this.svc_inv` in calling constructor.");
            return;
        }
        this.showCpSearchDialog = false;
        if (value != null) {
            this.setInventorySearchData(value);
            this.setDirty();
        }
    }

    delete(data: T) {
        if (this.saveMode == SaveMode.all) {
            if (!this.isNew) {
                let changedFlag: boolean = false;
                if (!CommonFunctions.getBoolValueIfNull(data.isAdded)) {
                    changedFlag = true;
                    this.addDeletedItem(data);
                }
                if (this.hasSelectedData && data.CID() == this.selectedData.CID()) {
                    this.grid.closeRow(this.editedRowIndex);
                    this.isNew = false;
                    this.editedRowIndex = undefined;
                    this.editForm = undefined;
                    this.showCpSearchDialog = false;

                }
                this.removeLocal(data);
                if (this.saveMode == SaveMode.all && changedFlag) {
                    this.sendParentMessage(MessageType.changed);
                }
            }
            else {
                this.cancelHandler();
            }
        }
        else {
            this.deleteIndividual(data);
        }
        this.afterDelete();
    }

    protected deleteSuccess(data: T) {
        this.globals.notifySuccess(this.appCode + " Deleted Successfully!");
    }
    protected deleteError(data: T, message: string) {
        this.globals.notifyError("Delete Encountered an Error: " + message, true);
    }
    askDeleteIfNew: boolean = true;
    deleteDialog(data: T) {
        if (data.isAdded && !this.askDeleteIfNew) {
            this.removeLocal(data);
            this.deletedLocalNoId();
            this.afterDelete();
        }
        else {
            this.cnfShow(CommonValues.Message_AreYouSureYouWantToDeleteThis, CRUDActions.Delete, data);
        }
    }

    confirmDialog(data: ConfirmOutput) {
        this.closeCtrlOpenFlag = true;
        let handled: boolean = false;
        if (data.dialogResult === CPDialogResult.ok) {
            switch (data.action) {
                case CRUDActions.Delete:
                    handled = true;
                    if (data.data.isAdded) {
                        this.removeLocal(data.data);
                        //this.closeEditor();
                        this.deletedLocalNoId();
                        this.afterDelete();
                    }
                    else {
                        this.delete(data.data);
                    }
                    break;
            }
        }
        if (!handled) {
            this.confirmCustom(data);
        }
    }

    warehouseCount = 0;
    public warehouse(id: string) {
        //this.warehouseCount = this.warehouseCount + 1;

        let retVal: any;
        if (CommonFunctions.hasValue(this.referenceData)) {
            if (this.superUseCPRefData) {
                retVal = this.referenceData.cpWarehouses.find(x => x.value === id);
            } else {
                retVal = this.referenceData.warehouses.find(x => x.value === id);
            }
        }
        return retVal;
    }
    public cpWarehouse(id: string) {
        //this.warehouseCount = this.warehouseCount + 1;

        let retVal: any;
        if (CommonFunctions.hasValue(this.referenceData)) {
            retVal = this.referenceData.cpWarehouses.find(x => x.value === id);
        }
        return retVal;
    }
    warehouseNameCount = 0;
    public warehouseName(id: string) {
        //this.warehouseNameCount = this.warehouseNameCount + 1;

        let data: GItem = this.warehouse(id);
        let name = "";
        if (CommonFunctions.hasValue(data)) {
            name = data.description;
        }
        return name;
    }
    public cPWarehouseName(id: string) {
        //this.warehouseNameCount = this.warehouseNameCount + 1;

        let data: GItem = this.cpWarehouse(id);
        let name = "";
        if (CommonFunctions.hasValue(data)) {
            name = data.description;
        }
        return name;
    }
    personCount = 0;
    public person(id: string) {
        //this.personCount = this.personCount + 1;

        let retVal: any;
        if (CommonFunctions.hasValue(this.referenceData)) {
            retVal = this.referenceData.personsSel.find(x => x.value === id);
        }
        return retVal;
    }
    personNameCount = 0;
    public personName(id: string) {
        //this.personNameCount = this.personNameCount + 1;

        let data: PersonSel = this.person(id);
        let name = "";
        if (CommonFunctions.hasValue(data)) {
            name = data.description;
        }
        return name;
    }
    public personNameFromUserId(id: string) {
        //this.personNameCount = this.personNameCount + 1;

        let data: PersonSel = this.personFromUserId(id);
        let name = "";
        if (CommonFunctions.hasValue(data)) {
            name = data.description;
        }
        return name;
    }
    public personFromUserId(id: string) {
        return this.referenceData.personsSel.find(x => x.userId === id);
    }
    manufacturerCount = 0;
    manufacturer(id: string) {
        //this.manufacturerCount = this.manufacturerCount + 1;

        return this.referenceData.manufacturers.find(x => x.value === id);
    }
    manufacturerTypeCount = 0;
    manufacturerType(id: string) {
        //this.manufacturerTypeCount = this.manufacturerTypeCount + 1;

        return this.referenceData.manufacturerTypes.find(x => x.value === id);
    }
    genericOpenCtrl(e: any) {
        this.ctrlOpenFlag = true;
    }
    genericCloseCtrl(e: any) {
        this.ctrlOpenFlag = false;
    }
    get canSaveForm(): boolean {
        return this.editForm?.valid && this.customCanSaveForm();
    }
    customCanSaveForm(): boolean {
        return true;
    }
    customMatches(e: any): boolean {
        return true;
    }
    private onDocumentClick(e: any): void {
        let shouldRunProcess: boolean = !this.ctrlOpenFlag && !this.showCpSearchDialog && this.canSaveForm;
        if (this.hasFeatureFlag("ui-hide-inventory-still-searching-notification")) {
            shouldRunProcess = !this.ctrlOpenFlag && !this.showCpSearchDialog && !this.inventorySearching && this.canSaveForm;
        } else {
            if (this.inventorySearching) {
                this.globals.notifyInfo("Please wait for the inventory search to complete. A notification will be displayed when the row is ready to be saved.");
                return;
            }
        }
        if (shouldRunProcess) {
            if (!this.editForm.dirty) {
                console.log("Form is not dirty", this.editForm);
                this.cancelHandler();
            }
            else {
                if (!this.noParentRequired && !this.hasParentId && this.saveMode === SaveMode.individual) {
                    this.actionSave = true;
                    this.sendParentMessage(MessageType.saveParent);
                }
                else {
                    if (!this.fieldNeedsValidation) {
                        this.saveCurrent();
                    }
                    else {
                        this.globals.notifyError("Please correct the validation errors on the row before saving.");
                        this.fieldNeedsValidation = false;
                        this.saveAfterFieldValidation = true;
                    }
                }
            }
        }
        else {
            if (this.closeCtrlOpenFlag) {
                this.ctrlOpenFlag = false;
                this.closeCtrlOpenFlag = false;
            }
        }
    }
    fieldNeedsValidation: boolean = false;
    saveAfterFieldValidation: boolean = false;
    closeCtrlOpenFlag: boolean = false;
    ctrlOpenFlag: boolean = false;
    setOpenFlag(state: boolean) {
        this.ctrlOpenFlag = state;
    }

    sendParentMessageByMessage(e: Message) {
        this.parentMessage.emit(e);
    }
    sendParentMessage(type: MessageType, subject: string = null, message: string = null, values: any = null, value: any = null) {
        let msg: Message = new Message();
        msg.messageType = type;
        msg.messageSubject = subject;
        msg.message = message;
        msg.values = values;
        msg.value = value;
        this.parentMessage.emit(msg);
    }
    showDQOI(id: any) {
        let msg: Message = new Message();
        msg.messageType = MessageType.dqoiPopup;
        msg.value = id;
        this.sendParentMessage(MessageType.dqoiPopup, null, null, null, id);
    }
    dispatchSearch: boolean = false;
    orderSearch: boolean = false;
    doDispatchSearch(e: any) {
        if (CommonFunctions.hasStringValue(e) && e === "CLEAR") {
            this.dispatchSelected({ dispatchNumber: "", dispatchId: null });
        }
        else {
            this.ctrlOpenFlag = true;
            this.dispatchSearch = true;
            setTimeout(() => {
                this.CpDispatchSearch?.setSearchText(e);
            }, 500);
        }
    }
    dispatchSelected(value: any) {
        this.dispatchSearch = false;
        if (value != null) {

            this.editForm.patchValue({
                dispatchNumber: value.DispatchNumber,
                dispatchId: value.DispatchId
            });
            this.customDispatchSelectedSetForm(value);
            if (this.saveAfterFieldValidation) {
                this.saveAfterFieldValidation = false;
                this.saveCurrent();
            }
            this.setDirty();
        }
        this.closeCtrlOpenFlag = true;
    }
    doOrderSearch(e: any) {
        if (CommonFunctions.hasStringValue(e) && e === "CLEAR") {
            this.orderSelected({ orderNumber: "", orderId: null });
        }
        else {
            this.ctrlOpenFlag = true;
            this.orderSearch = true;
            setTimeout(() => {
                this.CpDispatchSearch?.setSearchText(e);
            }, 500);
        }
    }
    orderSelected(value: any) {

        this.orderSearch = false;
        if (value != null) {

            this.editForm.patchValue({
                orderId: value.OrderId,
                orderNumber: value.OrderNumber
            });
            this.customDispatchSelectedSetForm(value);
            this.setDirty();
        }
        this.closeCtrlOpenFlag = true;
    }

    dispatchValidationError(event: any) {
        this.ctrlOpenFlag = true;
        this.dispatchSearch = true;
    }

    doDispatchValidate(value: any, customValidateCallback: () => void = null) {
        var skipCheck = false;
        if (!value) {

            this.editForm?.patchValue({
                dispatchNumber: value,
                dispatchId: null
            });
            skipCheck = true;
        }
        else {
            var dispatchId = this.editForm.controls["dispatchId"].value;
            var dispatchNumber = this.editForm.controls["dispatchNumber"].value;
            if (dispatchId) {
                if (dispatchNumber === value) { skipCheck = true; }
            }
        }

        if (!skipCheck) {
            if (customValidateCallback) {
                customValidateCallback();
            } else {
                this.dispatchSearch = false;
                this.CpDispatchSearch.validate(value);
            }
        }
    }

    cnfShow(message: string, action: CRUDActions = CRUDActions.None, data: any = null, title: string = null, code: string = null, okButtonOnly = null) {
        this.ctrlOpenFlag = true;
        if (CommonFunctions.hasValue(this.cnfDialog)) {
            this.cnfDialog.show(message, action, data, title, code, okButtonOnly);
        }
    }
    cnfShowNote(note: string, title: string = null) {
        this.ctrlOpenFlag = true;
        if (CommonFunctions.hasValue(this.cnfDialog)) {
            this.cnfDialog.showNote(note, title);
        }
    }

    cnfShowCustomValue(value: any, valueType: number = 1, title: string = null) {
        this.ctrlOpenFlag = true;
        if (CommonFunctions.hasValue(this.cnfDialog)) {
            this.cnfDialog.showCustomValue(value, valueType, title);
        }
    }
    close(e: any) {
        this.closed.emit(e);
    }
    closeWithInfo(info: BaseMessageInfo) {
        this.closedWithInfo.emit(info);
    }

    protected sumAggregates(gridData: T[] = null) { }

    public iconClass: string = 'fa fa-2x fa-download gridExportBtnClass';
    public exportData: Array<any> = [
        {
            text: 'Excel',
            icon: 'excel'
        }, {
            text: 'Pdf',
            icon: 'pdf'
        }];

    public onSplitButtonClick(e?: string): void {

        if (e === "Pdf") {
            this.exportGridToPDF();
        }
        else {
            if (this.DefaultExport === "Excel") {
                this.exportGridToExcel();
            }
            else {
                this.exportGridToPDF();
            }
        }
    }

    public exportGridToPDF(): void {
        this.grid.saveAsPDF();
    }
    public exportGridToExcel(): void {
        this.grid.saveAsExcel();
    }
    public allData(indata: ExcelExportData): ExcelExportData {
        if (!this.gridData) {
            this.gridData = [];
        }
        const result: ExcelExportData = {
            data: process(this.gridData as any, {}).data,
        };
        return result;
    }
    public showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === 'TD' || element.nodeName === 'TH')
            && element.offsetWidth < element.scrollWidth) {
            this.tooltipDir.toggle(element);

        } else {
            this.tooltipDir.hide();
        }
    }
    messageHandler(e: Message) {
        if (e.messageType === MessageType.changed) {
            this.messageChanged(e);
        }
        else {
            this.customMessageHandler(e);
        }

    }
    protected messageChanged(e: Message) {
        this.setDirty();
        this.SetChanged();
    }

    dragDivClick(e: any) {

        if (this.isEditing && this.canSaveForm) {
            this.saveCurrent();
        }
    }

}

